import SouscriptionSupportingDocumentsForm from './SouscriptionSupportingDocumentsForm';
import { Loading } from '@fasstech/middle-design-system';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import useGetSouscriptionSupportingDocumentsQuery from './hooks/useGetSouscriptionSupportingDocumentsQuery';

const SouscriptionSupportingDocuments = ({ getMiddleText, getMiddleBoolean, middleFeatures }) => {
  const {
    getSouscriptionSupportingDocuments,
    loading: isFetchingGetSouscriptionSupportingDocuments
  } = useGetSouscriptionSupportingDocumentsQuery();

  const { processHandlers, context } = useProcess();

  if (isFetchingGetSouscriptionSupportingDocuments) return <Loading />;

  return (
    <SouscriptionSupportingDocumentsForm
      data={getSouscriptionSupportingDocuments}
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      middleFeatures={middleFeatures}
      context={context}
      processHandlers={processHandlers}
    />
  );
};

export default withMiddleFeatures(SouscriptionSupportingDocuments);
